import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { productionCenterQueryKeys } from './query-keys';

export type TDeleteProductionCenterParams = {
  id: string;
};

export function deleteProductionCenter({ id }: TDeleteProductionCenterParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/production_centers/${id}`);
}

type MutationFn = typeof deleteProductionCenter;

type UseDeleteProductionCenterParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteProductionCenter({ config }: UseDeleteProductionCenterParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('El centro de producción no existe');
      }
      addErrorNotification('No se ha podido eliminar el centro de producción');
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: productionCenterQueryKeys.all });
      addSuccessNotification('El centro de producción se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteProductionCenter,
  });
}
